<template>
  <div
    v-if="currentLocation"
    class="text-accent row items-center"
  >
    <div
      class="q-mr-md phoneNumber"
    >
      s. 517 1818
    </div>
    <div class="q-mr-md openingHours">
      /
    </div>
    <div v-if="openWhen && !currentLocation.closed">
      <div class="openingHours">
        {{ $t('location.openingHours') }}: {{ openWhen }}
      </div>
    </div>
    <div v-else>
      <div class="openingHours">
        {{ $t('location.noOpeningHours') }}
      </div>
    </div>
  </div>
</template>

<script>
import { constants } from 'quasar-pilot-core/src/lib/constants';
import { date } from 'quasar';
import { mapState } from 'vuex';

export default {
  name: 'LayoutOpeningHours',

  data() {
    return {
      openWhen: '',
    };
  },

  computed: {
    ...mapState('application', ['defaultDeliveryMethod']),
    ...mapState('location', { currentLocation: 'current' }),

    isOpen() {
      return this.currentLocation.isOpen(this.defaultDeliveryMethod.id);
    },
  },

  watch: {
    currentLocation() {
      this.openWhen = this.getOpeningString(this.defaultDeliveryMethod.id);
    },
  },

  created() {
    this.openWhen = this.getOpeningString(this.defaultDeliveryMethod.id);
  },

  methods: {
    getOpeningString(deliveryMethodId) {
      const preferredDeliveryMethodId = (deliveryMethodId) || constants.DEFAULT_DELIVERY_METHOD;
      const openingHours = this.currentLocation.getOpeningHoursToday(preferredDeliveryMethodId);
      if (!openingHours) {
        return '';
      }

      const open = new Date();
      open.setTime(openingHours.start * 60 * 1000);
      const close = new Date();
      close.setTime((openingHours.end + 15) * 60 * 1000);

      return `${date.formatDate(open, 'H:mm')} - ${date.formatDate(close, 'H:mm')}`;
    },
  },
};
</script>

<style lang="scss" scoped>
.phoneNumber {
  font-size: 18px;
  font-weight: 600;

  @media(max-width: 600px) {
    font-size: 14px;
    font-weight: 500;
  }
}

.openingHours {
  font-size: 16px;
  font-weight: 600;
  @media(max-width: 600px) {
    font-size: 14px;
    font-weight: 500;
  }
}
</style>
